import React, { useEffect, useRef, useState } from 'react';

import {
   Box,
   Paper,
   Tooltip,
   IconButton,
   Menu,
   MenuItem,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TitleLabel } from '../../../../Element/LabelInputForm';
import { Input } from '../../../../../assets/styled/Element';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons';
import SwitchIOS from '../../../../Switch/SwitchIOS';

const useStyles = makeStyles((theme) => ({
   containerPaper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
   },
   paper: {
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
      margin: '0 24px',
      width: '80%',
   },
   section: {
      height: '25px',
      backgroundColor: '#ffd657',
      padding: '0 10px',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '16px',
   },
}));

const QuestionSectionComponent = ({
   value,
   onValueChange,
   onDeleteSection,
   onDuplicateSection,

   totalSections,
   sectionNumber,
   onSectionData,
}) => {
   const classes = useStyles();

   const [myMenu, setMyMenu] = useState(null);
   const [selectedOption, setSelectedOption] = useState('');

   // ฟังก์ชันสำหรับจัดการการเปลี่ยนค่าของ input
   const handleInputChange = (e) => {
      const { name, value: inputValue } = e.target; // ดึง `name` และ `value` จาก event

      onValueChange({
         ...value, // คัดลอกค่าปัจจุบัน
         [name]: inputValue, // อัปเดตฟิลด์ที่เปลี่ยนแปลง
      });
   };

   const handleIsBeakPage = (isChecked) => {
      onValueChange({
         ...value,
         isBreakPage: isChecked,
      });
   };

   // ฟังก์ชันเปิดเมนู
   const handleMyMenuClick = (event) => {
      setMyMenu(event.currentTarget);
   };

   // ฟังก์ชันปิดเมนู
   const handleMyMenuClose = () => {
      setMyMenu(null);
   };

   // ฟังก์ชันเลือกเมนูและปิด
   const handleMenuItemSelect = (values) => {
      if (values === 'delete') {
         //ส่งค่าไปที่หน้า Create เพื่อเรียก API ลบ section
         onDeleteSection(value);
      } else if (values === 'duplicate') {
         console.log('duplicate');
         onDuplicateSection(value);
      }

      setTimeout(() => handleMyMenuClose(), 0);
   };

   return (
      <div className={classes.containerPaper}>
         {/* ส่วนของ section name และ section description */}
         <Paper className={classes.paper} style={{ marginBottom: '0.8rem' }}>
            <Box width={'100%'} height={'10px'} bgcolor={'black'}></Box>
            <Box padding={'8px 32px 24px'}>
               <Box mb={2}>
                  <Box
                     display={'flex'}
                     justifyContent={'space-between'}
                     alignItems={'center'}
                  >
                     <TitleLabel Fs={'20px'}>Section Name</TitleLabel>
                     <Box
                        display={'flex'}
                        alignItems={'center'}
                        gridGap={'10px'}
                     >
                        <Box
                           display={'flex'}
                           gridGap={'5px'}
                           alignItems={'center'}
                           paddingRight={'12px'}
                        >
                           <TitleLabel Fs={'18px'}>
                              แบ่งหน้าระหว่างคำถาม
                           </TitleLabel>
                           <SwitchIOS
                              activeText='O'
                              inactiveText='-'
                              width='48px'
                              checked={value.isBreakPage}
                              onChange={handleIsBeakPage}
                           />
                        </Box>

                        <Box className={classes.section}>
                           Section {sectionNumber} / {totalSections}
                        </Box>

                        <Tooltip title='เพิ่มเติม' onClick={handleMyMenuClick}>
                           <IconButton aria-label='เพิ่มเติม'>
                              <FontAwesomeIcon
                                 color='#000000'
                                 icon={faEllipsisH}
                                 style={{ fontSize: '18px' }}
                              />
                           </IconButton>
                        </Tooltip>

                        <Menu
                           id='simple-menu'
                           anchorEl={myMenu}
                           keepMounted
                           open={Boolean(myMenu)} // ตรวจสอบว่ามี anchorEl หรือไม
                           onClose={handleMyMenuClose}
                           anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                           }}
                           transformOrigin={{
                              vertical: 'top',
                              horizontal: 'bottom',
                           }}
                        >
                           {(totalSections === 1
                              ? [
                                   {
                                      value: 'duplicate',
                                      label: 'Duplicate',
                                   },
                                ]
                              : [
                                   {
                                      value: 'delete',
                                      label: 'Delete',
                                   },
                                   {
                                      value: 'duplicate',
                                      label: 'Duplicate',
                                   },
                                ]
                           ).map((item) => (
                              <MenuItem
                                 key={item.value}
                                 selected={selectedOption === item.value}
                                 onClick={() =>
                                    handleMenuItemSelect(item.value)
                                 }
                              >
                                 <Box
                                    display='flex'
                                    alignItems='center'
                                    gridGap={'10px'}
                                 >
                                    <Typography style={{ fontSize: '20px' }}>
                                       {item.label}
                                    </Typography>
                                 </Box>
                              </MenuItem>
                           ))}
                        </Menu>
                     </Box>
                  </Box>

                  <Input
                     name={'secNameTh'}
                     placeholder={'Section Name'}
                     value={value.secNameTh}
                     onChange={handleInputChange}
                  />
               </Box>

               <Box>
                  <TitleLabel Fs={'20px'}>Section Description</TitleLabel>
                  <Input
                     name={'secDescTh'}
                     placeholder={'Section Description'}
                     value={value.secDescTh}
                     onChange={handleInputChange}
                  />
               </Box>
            </Box>
         </Paper>
      </div>
   );
};

export default QuestionSectionComponent;
